import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import API from '../../../../Configs';

class ReportBody extends Component {
    constructor(props){
        super(props);
        this.meta = API.REPORTS;
        this.ageMeta = API.REPORT_AGES;
        this.reportType = this.meta[props.reportId];
    }

    render(){

        const { ageMeta, reportType: { queryField, apiField, dataType, detailsPage="jobs" }, props: { reports, reportId } } = this;
        return (
            Object.values(reports).map((row , id) => {
                const reportType = row[apiField] === null || row[apiField] === undefined ? "" : row[apiField];
                const { name = reportType, id: searchId = name } = reportType;            
                return(
                    <tr key={id}>
                        <td style={{padding:"0.5rem"}} className="text-left">
                            <Link to={`/${detailsPage}#${queryField}=${searchId}&status[]=1&status[]=2&status[]=3&status[]=4&status[]=5&report=${reportId}`}>{ name }</Link>
                        </td>
                        <td className="text-right" style={{padding:"0.5rem", backgroundColor: "#f4f4f4",fontWeight: "bold"}}>
                            <Link to={`/${detailsPage}#${queryField}=${searchId}&status[]=1&status[]=2&status[]=3&status[]=4&status[]=5&report=${reportId}`}>{ row.total }</Link>
                        </td>
                        {dataType === 1 ? 
                            <td className="text-right" style={{padding:"0.5rem", backgroundColor: "#f4f4f4",fontWeight: "bold"}}>
                                <Link to={`/${detailsPage}#${queryField}=${searchId}&status[]=1&status[]=2&status[]=3&status[]=4&report=${reportId}`}>{row.open}</Link>
                            </td>
                        :false}
                        {dataType === 1 ?
                            Object.keys(API.STATUSES).map((id) => (
                                <td style={{padding:"0.5rem"}} className="text-right" key={id}>
                                    <Link to={`/${detailsPage}#${queryField}=${searchId}&status=${id}&report=${reportId}`}>{row[`s${id}`]}</Link>
                                </td>
                            ))
                        :
                            Object.keys(ageMeta).map((id) => (
                                <td style={{padding:"0.5rem"}} className="text-right" key={id}>
                                    <Link to={`/${detailsPage}#${queryField}=${searchId}&ageFrom=${ageMeta[id].from}&ageTo=${ageMeta[id].to}&report=${reportId}`}>{row[`s${id}`]}</Link>
                                </td>
                            ))
                        }
                    </tr>
                );       
            })
        )        
    }

}

const mapStateToProps = (state) => ({
    reports: state.reportStore.reports,
    query: state.reportStore.query,
});

export default connect(mapStateToProps)(ReportBody);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/TabularReport/ReportBody.js